<template>
  <v-snackbar v-model="show" :timeout="5000" top :color="color">
    <span>{{text}}</span>
    <v-btn outlined fab color="white" @click="show=false"><v-icon>mdi-close</v-icon></v-btn>
  </v-snackbar>
</template>

<script>
import ACTIONS from '@/store/storeActions';

export default {
  name: 'MessageBar',
  data() {
    return {
      show: false,
      text: null,
      color: null,
    };
  },
  methods: {
  },
  computed: {

  },
  created() {
    this.$store.watch((state) => state.snackbar.text, () => {
      const msg = this.$store.state.snackbar.text;
      const { color } = this.$store.state.snackbar;

      if (msg && msg !== '') {
        this.color = color || 'info';
        this.show = true;
        this.text = this.$store.state.snackbar.text;
        this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: '', color: 'info' });
      }
    });
  },
};
</script>
